import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Country, District, State } from 'app/masters/models/branch-master.model';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { LocationService } from '../location.service';
import { SearchCityMasterComponent } from './search-city-master/search-city-master.component';

@Component({
  selector: 'app-city-master',
  templateUrl: './city-master.component.html',
  styleUrls: ['./city-master.component.scss']
})
export class CityMasterComponent implements OnInit {
  public selectCityObj: any = {};
  selectedCityId: number;
  cityForm: FormGroup;
  activeCountry: Country[] = [];
  activeState: State[] = [];
  activeDistrict: District[] = [];
  filteredCountryArray: Observable<any[]>;
  filteredStateArray: Observable<any[]>;
  filteredDistrictArray: Observable<any[]>;
  fkCountryId: FormControl;
  fkStateId: FormControl;
  fkDistrictId: FormControl;
  countryIndex = [];
  stateIndex = [];
  districtIndex = [];
  districtLists: any;
  SavingPayLoad: any;
  countryName: string;
  stateName: string;
  districtname: string;
  disabled = true;
  popbutton:number;
  enabledisablebtn:boolean =false;
  citylistDataAll: any;
  stateData: any;
  districtData: any;
  countryData: any;
  constructor(public dialog: MatDialog, public locationService: LocationService, private _fb: FormBuilder,public dialogRef: MatDialogRef<CityMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.getCountryList();
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.enabledisablebtn=true;
    this.popbutton =0;
    if(this.data.id !=null && this.data.id !=undefined){
      this.popbutton =this.data.id;
    }
    this.loadCityForm();
    this.countryControll();
    this.StateControll();
    this.districtControll();
    this.countryIndex = [];
    this.stateIndex = [];
    this.districtIndex = [];
    this.disabled = true;
    this.getCityListAll();
  }
  closedailog(){
    this.dialogRef.close();
  }

  loadCityForm() {
    this.enabledisablebtn=true;
    this.cityForm = this._fb.group({
      pkCityId: ' ',
      fkCountryId: ['', [Validators.required]],
      cityName: [{ value: '', disabled: this.disabled }, [Validators.required]],
      fkDistrictId: [{ value: '', disabled: true }, [Validators.required]],
      fkStateId: [{ value: '', disabled: true }, Validators.required],
      isActive: false,
      stateName: '',
      districtname: '',
      countryName: ''
    });
  }
  enableButton($event){    
    const form = this.cityForm.controls;
    if(form.fkCountryId.value == '' || form.fkStateId.value == '' || form.cityName.value == '' || form.fkDistrictId.value== ''){
      this.enabledisablebtn= true;
    }else{
      this.enabledisablebtn=false;
    }
  }
  getCityListAll(){
    this.locationService.getCityItem(0).subscribe(data => {
      this.citylistDataAll = data;
    })
  }
  saveDistrictForm() {    
    let districtId
    const form = this.cityForm.controls;
    let districtname = this.districtData.filter(item => item.districtname == form.fkDistrictId.value);
    if (districtname.length == 0) {
      this.locationService.openSnackBar("Please select a valid district", "OK");
      return;
    }
    districtId = districtname[0].pkDistrictId;
    
  
    let countryname = this.countryData.filter(item => item.countryName == form.fkCountryId.value);
    if (countryname.length == 0) {
      this.locationService.openSnackBar("Please select a valid country", "OK");
      return;
    }
    let statename = this.stateData.filter(item => item.stateName == form.fkStateId.value);
    if (statename.length == 0) {
      this.locationService.openSnackBar("Please select a valid state", "OK");
      return;
    }
      

  
    // if (districtname.length != 0) {
    //   districtId = districtname[0].pkDistrictId;
    // } else {
    //   districtId = '';
    //   this.locationService.openSnackBar("The District Name Empty", "OK");
    // }
    if (form.pkCityId.value === ' ') {
      const cityNameData = this.citylistDataAll.filter(item => 
        item.cityName.toLowerCase() === form.cityName.value.toLowerCase() &&
        item.fkDistrictId === districtId 
      );   
       if(cityNameData.length >0){      
          this.locationService.openSnackBar("Already Exists in  list" , "OK");
          this.loadCityForm();
          return
      }
    this.SavingPayLoad = {
      cityName: form.cityName.value,
      fkDistrictId: districtId,
      isActive: form.isActive.value,
      pkCityId: form.pkCityId.value
    }
      delete this.SavingPayLoad.pkCityId;
      this.locationService.addCityMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.locationService.openSnackBar("Record Saved Successfully ", "OK");
          this.loadCityForm();
          this.getCityListAll();
        }
      },
      err => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
   
      }
    );
    } else {
      this.SavingPayLoad = {
        cityName: form.cityName.value,
        fkDistrictId: districtId,
        isActive: form.isActive.value,
        pkCityId: form.pkCityId.value
      }
      this.locationService.addCityMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.locationService.openSnackBar("Record Updated Successfully " , "OK");
          this.loadCityForm();
          this.getCityListAll();
        }
      },
      err => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    }
  }

  /** Reset the Form */
  resetForm() {
    this.loadCityForm();
    this.stateIndex = [];
    this.countryIndex = [];
    this.districtIndex = [];
    this.disabled = true;
    this.countryName = '';
    this.cityForm.controls.fkStateId.disable();
    this.cityForm.controls.fkDistrictId.disable();
    this.cityForm.controls.cityName.disable();
  }

  /* Get Country APi */
  getCountryList() {
    this.locationService.getCountry().subscribe(data => {
      let countryListActive = data;
      this.countryData = data
      for (var _i = 0; _i < countryListActive.length; _i++) {
        if (countryListActive[_i].isActive == true) {
          this.countryIndex.push(countryListActive[_i]);
          this.activeCountry = this.countryIndex;
        }
      }
      this.countryControll();
    });
  }
  countryControll() {
    this.fkCountryId = new FormControl();
    this.filteredCountryArray = this.fkCountryId.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterCountryfunction(country) : this.activeCountry.slice())
      );
  }

  filterCountryfunction(name: string) {
    return this.activeCountry.filter(country =>
      country.countryName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  StateControll() {
    this.fkStateId = new FormControl();
    this.filteredStateArray = this.fkStateId.valueChanges
      .pipe(
        startWith(''),
        map(State => State ? this.filterStatefunction(State) : this.activeState.slice())
      );
  }

  filterStatefunction(name: string) {
    return this.activeState.filter(State =>
      State.stateName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  districtControll() {
    this.fkDistrictId = new FormControl();
    this.filteredDistrictArray = this.fkDistrictId.valueChanges
      .pipe(
        startWith(''),
        map(District => District ? this.filterDistrictfunction(District) : this.activeDistrict.slice())
      );
  }

  filterDistrictfunction(name: string) {
    return this.activeDistrict.filter(District =>
      District.districtname.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  /** Seach City Master */
  searchCityMaster() {
    const dialogRef = this.dialog.open(SearchCityMasterComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "450px",
      width: "50%",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectCityObj = this.locationService.selecteCityData
      if (this.selectCityObj != null) {
        this.enabledisablebtn=false;
        this.selectedCityId = this.selectCityObj.pkCityId;
        this.setupdateCityForm(this.selectedCityId);
      }
    });
  }

  setupdateCityForm(cityId) {
    let selectedCitydata;
    this.locationService.getCityItem(cityId).subscribe(data => {
      selectedCitydata = data[0];
      this.cityForm.patchValue(
        {
          pkCityId: selectedCitydata.pkCityId,
          fkCountryId: selectedCitydata.countryName,
          cityName: selectedCitydata.cityName,
          fkDistrictId: selectedCitydata.districtname,
          fkStateId: selectedCitydata.stateName,
          isActive: selectedCitydata.isActive
          // pkSynchId: selectedCitydata.pkSynchId
        });
      // let event = {
      //   option: {
      //     id: selectedCitydata.fkCountryId
      //   }
      // }
      this.changeCountry(selectedCitydata.fkCountryId);
      this.changeState(selectedCitydata.fkStateId);
      this.districtSelect(selectedCitydata.fkDistrictId);
    });

  }

  changeCountry(eventId, isManual: boolean = false) {
    this.enableButton(eventId);
    let selectedCountry = eventId;
    this.stateIndex = [];
    this.activeState = [];
    this.districtIndex = [];
    this.activeDistrict = [];
    this.locationService.getState().subscribe(data => {
      let StateActive = data;
      this.stateData = data
      for (var i = 0; i < StateActive.length; i++) {
        if (StateActive[i].isActive == true && StateActive[i].fkCountryId == selectedCountry) {
          this.stateIndex.push(StateActive[i]);
          this.activeState = this.stateIndex;
          this.cityForm.controls.fkStateId.enable();
        }
      }
      if (isManual) {
        this.StateControll();
        this.cityForm.patchValue(
          {
            cityName: '',
            fkDistrictId: null,
            fkStateId: null,
            isActive: false
          });
      }
    });
  }

  changeState(event, isManual: boolean = false) {
    this.enableButton(event);
    let selectStatetId = event;
    this.districtIndex = [];
    this.activeDistrict = [];
    this.locationService.getDistrict(0).subscribe(data => {
      let districtList = data;
      this.districtData = data;
      for (var i = 0; i < districtList.length; i++) {
        if (districtList[i].isActive == true && districtList[i].fkStateId == selectStatetId) {
          this.districtIndex.push(districtList[i]);
          this.activeDistrict = this.districtIndex;
          this.cityForm.controls.fkDistrictId.enable();
          this.cityForm.controls.cityName.enable();
          this.disabled = false;
        }
      }
      if (isManual) {
        this.districtControll();
        this.cityForm.patchValue(
          {
            fkDistrictId: null,
            cityName: '',
            isActive: false
          });
      }
    });
  }
  districtSelect(e){
this.enableButton(e.option.id);
  }
}
